import request from '@/utils/request'

/**
 * 查询服务评价列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function queryShopAppraise(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise/queryShopAppraise',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 后台新增服务评价
 * @param {Object} data
 * @returns {Promise}
 */
export function saveShopAppraise(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise/saveShopAppraiseAdmin',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg || '保存失败')
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改服务评价
 * @param {Object} data
 * @returns {Promise}
 */
export function updateShopAppraise(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise/updateShopAppraise',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg || '修改失败')
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除服务评价
 * @param {Object} data
 * @returns {Promise}
 */
export function deleteShopAppraise(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise/deleteShopAppraise',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg || '删除失败')
      }
    }).catch(error => {
      reject(error)
    })
  })
}
